import React from "react";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  button: {
    marginRight: 8,
    padding: "4px 16px",
    borderRadius: 16,
    fontWeight: "600",
    cursor: "pointer",
    height: "100%",
    color: "#fff",
  },
  buttonGrey: {
    backgroundColor: "#666666",
  },
  buttonBlue: {
    backgroundColor: "#140c41",
  },
});

export default function ({ onClick, children, isBlue }) {
  const classes = useStyles();
  return (
    <div
      onClick={onClick}
      className={`${classes.button} ${
        isBlue ? classes.buttonBlue : classes.buttonGrey
      }`}
    >
      {children}
    </div>
  );
}
